export default class RouteDetails {
  /** @param {Object} data
   * @param {string[]} data.trackNames
   * @param {number} data.ferryDistance
   * @param {number} data.otherTypeDistance
   * @param {number} data.winderRoadDistance
   * @param {number} data.commonDistance
   * @param {number} data.trunkDistance
   * @param {number} data.motorwayDistance
   * @param {number} data.platonDistance
   * @param {number} data.tollDistance
   * @param {number} data.mkadDistance
   * @param {number} data.totalDistance
   * @param {number} data.totalTime
   */
  constructor({
                trackNames,
                ferryDistance,
                otherTypeDistance,
                winderRoadDistance,
                commonDistance,
                trunkDistance,
                motorwayDistance,
                platonDistance,
                tollDistance,
                mkadDistance,
                totalDistance,
                totalTime
              } = {}) {
    /** @type {string[]} */
    this.trackNames = trackNames;
    /** @type {number} */
    this.ferryDistance = ferryDistance;
    /** @type {number} */
    this.otherTypeDistance = otherTypeDistance;
    /** @type {number} */
    this.winderRoadDistance = winderRoadDistance;
    /** @type {number} */
    this.commonDistance = commonDistance;
    /** @type {number} */
    this.trunkDistance = trunkDistance;
    /** @type {number} */
    this.motorwayDistance = motorwayDistance;
    /** @type {number} */
    this.platonDistance = platonDistance;
    /** @type {number} */
    this.tollDistance = tollDistance;
    /** @type {number} */
    this.mkadDistance = mkadDistance;
    /** @type {number} */
    this.totalDistance = totalDistance;
    /** @type {number} */
    this.totalTime = totalTime;
  }
}